import { action } from 'satcheljs';

export default action(
    'clearSelectedConversationInModule',
    function clearSelectedConversationInModule() {
        return {};
    }
);
